import React from 'react';
import "./discoverySectionComponent.scss";
import DiscoverySectionTitle from "./components/DiscoverySectionTitle";
import DiscoverySectionItemList from "./components/DiscoverySectionItemList";

const DiscoverySectionComponent = () => {
    return (
        <div className="discoverySectionComponent__container">
            <DiscoverySectionTitle />
            <DiscoverySectionItemList />
        </div>
    );
};

export default DiscoverySectionComponent;